import { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import React from 'react';

import CrossPlatformLink from '@swf/components/Link/CrossPlatformLink';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderUS.scss';

const RegulatoryHeaderUS: React.FC<Props> = ({
  regulatory_header: [
    {
      texts,
      icons: [icon]
    }
  ]
}) => {
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);

  return (
    <div className={styles.responsibleGaming}>
      <span className={styles.regulatoryText}>
        <CMSHTML content={texts[0].content} />
      </span>
      <CrossPlatformLink href={helpResponsibleGaming}>
        <CMSImage className={styles.regulatoryIcon} {...icon} />
      </CrossPlatformLink>
      <CrossPlatformLink href={helpResponsibleGaming} className={styles.regulatoryIconText}>
        <CMSHTML content={texts[1].content} />
      </CrossPlatformLink>
    </div>
  );
};

export default RegulatoryHeaderUS;
